const resumeData = {
  name: "Ravindu Madhubhashana",
  role: "Full Stack Software Engineer",
  about:
    "I am a dedicated software engineer with a Bachelor's degree in Computer Science and currently pursuing a Master's in the same field. With hands-on experience in backend and frontend development, I have contributed to real-world projects involving system design, API integration, encryption, and scalable frontend solutions using technologies like Java, Spring Boot, ReactJS, MySQL, MongoDB, and Redis. My work experience spans e-commerce platforms, chat applications, and financial solutions. I’ve handled complex tasks such as implementing custom encryption layers, integrating third-party services, and enhancing user interfaces. I am passionate about writing clean, efficient code and continuously learning to keep up with evolving technologies. Eager to contribute to forward-thinking teams, I am looking for opportunities to leverage my technical and problem-solving skills to create meaningful impact and continue growing as a developer.",
  projects: [
    {
      title: "SLHandyFix",
      description: "A platform for service providers and consumers to connect and fix issues.",
      link: "https://github.com/RAVINDULM/SLHandyFixMobile",
    },
    {
      title: "PCMart",
      description: "A simple e-commerce flutter app for computer accessories.",
      link: "https://github.com/RAVINDULM/PCMart",
    },
  ],
  skills: ["JavaScript", "React", "Node.js", "MongoDB", "CSS"],
  experience: [
    {
      company: "iCan Lanka PVT(Ltd)",
      companyLogo:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAuCAYAAACiR6CHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAN7SURBVHgBzVhdVtpAFP5mUPT0ib5W28YVSFdQXUF1BcWXHuyLugJxBcWX4mkftCsQV2BcQdkBOVXrK33pESSZ3jsBhECYCYbY75xoMkwmX+7cn+9GoI/Pd4dQQYnOHDpaEKgj6BzhZM1DRhAhkdufUChO+L2FrtrE99UGMoAMLTKRCKOABXGOjCBpa7YMcxyUrzeQASQdRfM04SADMBnPPE1ZzHk6eJt+GOZ4OHntIgNIelAFSsURakF1NpERxOCsfFOiq72efxCJ4ALoVrPMM/8VBHZ/Xxpn+d1jfHtTH1zvNwu4XygiEEVIVYCUb/W4UmRR9QdCNaD8RlKrEplbZZyl1A6WH+r4u1hCTn6ggQ3YQIBIKRfq4diGmB0ZCJcIcD4qYFYInJlqnYQVtCVmJ6KXAAVIvqnLTwwsLZMyePuCznbUSpaWSRlcmEX+EuWmg2cnE8KJEnpOMgwHMj+QKGmRafWO5OAtK19X8EQydSoZm1jqvERtpX8IPRbWOs96JSHe63/Jo0knsR1jEguz9D6EPJy+ljrqq4JkZPiNT1ZLSAJdgMVpZNSjGnOA2lCJSUZG1FF7tY1ZsHuzT/d/QagGjrVsmYAF2EK1DzAraqtVslBL17fqWqyj21mG68rXlR3MGXbRFBilaSqwIzNJA7Nj9rMnR87ur8eWh88jqd4GNj7jjY18IocU5JAqT9IUW2jnWaAVyVEPKImRT1D0iBx3oe+QMplx6aDg0p8G+ZLbG6BtFAXKP3X4i9SFstJTF0gIduAmwmY/Hpxlp0RBWmCfMT/kftHUAqcCbuKujLOE/IgMIEnJu+ZpJDuHoyUpyneO7kI4AqeSWfJdWJX/3Oks4Ro+JTjXL8Q1in00hlTYUZavq7QVexbLerrdte2HOP+0l84ntzbUcaj2SPXvkSEziqAJW1i0Hb1qzfLBgeVaQ722tXWGV6K38ykAhKcvA/2la53yEPtXktbGI2G29pj0lrsVyqTULRreZATsB3JjcJnjISSHCnQRfqxNnNS6ivXK3JNbhMhA6Y0WSv1V05+7VIgQqfQvx6u2loL+/C0UIcIQsZPDCONq7CBd0EuSCGf1F4Ew3so9zVSFnwTTOwszGU2IrAS/0utvHCTGaEsSBzsyw+AapeQW3blOt8d9Q/boaMBXV3jxcGYrP5KTiSJar5bJJ2bUPv8Atd90Ah7XJOYAAAAASUVORK5CYII=",
      role: "Software Engineer",
      duration: "2025 January - Present",
      techStack:
        "Java, Spring Boot, Redis, MongoDB, MySQL, Reac-tJS, TailwindCSS",
      workList: [
        "Implemented encryption and decryption for sensitive configuration data in Redis and MySQL using custom Spring AOP annotations.",
        "Developed and managed CRUD APIs for features such as splash screen management and dynamic system configuration on both admin and client sides.",
        "Enhanced chat application by enabling post categorization, dynamic country and currency updates, and new notification types.",
        "Created scheduled jobs and APIs to delete outdated chat data and associated media from MongoDB and Alibaba Cloud OSS.",
        "Designed and developed the company’s new official website using ReactJS and TailwindCSS.",
      ],
    },
    {
      company: "Red Quantum Software Engineering PVT LTD",
      companyLogo:
        "https://media.licdn.com/dms/image/v2/D4D0BAQGHBwoDcC33XA/company-logo_200_200/company-logo_200_200/0/1695279284356?e=1754524800&v=beta&t=7dymxZ2FdlhcifK2JubgP8f7eN8tM6v3j8_NfFekcho",
      role: "Software Engineer",
      duration: "2023 October - 2024 December",
      techStack: "ReactJS, Redux, React Query, TailwindCSS, Java, Spring Boot",
      workList: [
        "Developed and maintained back-end functionalities for the admin-side applications.",
        "Built and enhanced front-end interfaces for both client and admin applications using ReactJS, Redux, and TailwindCSS.",
        "Designed and implemented wallet-related features, including deposits, withdrawals, savings accounts, and transaction management.",
        "Addressed and resolved bugs across various modules of the system to improve application performance and user experience.",
        "Participated in bug fixing and optimization of a large-scale backend data distribution system used by multiple internal projects.",
        "Conducted knowledge transfer (KT) sessions to share expertise in software engineering and back-end development.",
        "Followed Agile methodologies to ensure efficient development cycles and collaboration.",
      ],
    },
    {
      company: "Entgra PVT(Ltd)",
      companyLogo: "https://docs.entgra.io/uem/6.4.0/images/logo.png",
      role: "Software Engineer",
      duration: "2022 November - 2023 May",
      techStack: "Java EE, React, Google Cloud Platform (GCP)",
      workList: [
        "Debugged and resolved issues in both frontend and backend systems.",
        "Conducted research on the WSO2 Governance Registry, an older WSO2 product, to modernize its UI and develop new APIs.",
        "Gained experience with GCP by automating data read/write operations using the Google Sheets API.",
        "Designed and developed UI/UX solutions using Figma and React.",
      ],
    },
  ],
  education: [
    {
      degree: "Master of Computer Science (Reading)",
      institution: "University of Colombo School of Computing",
      duration: "2024 – Present",
      logo: "https://ugvle.ucsc.cmb.ac.lk/pluginfile.php/2/course/section/2/UCSC_logo1.jpg?time=1745557854109", // You can replace this with a real path
      highlights: [
        "Covering advanced concepts in Software Engineering, Databases, and Data Structures & Algorithms.",
        "Learning machine learning and deep learning concepts with practical applications.",
        "Exploring emerging areas such as Game Development, Computer Vision, and Natural Language Processing.",
        "Conducting comprehensive academic research with a strong focus on problem-solving and innovation.",
        "Studying theoretical foundations including Automata Theory, Computability, and Computational Complexity.",
        "Improving skills in system design, distributed computing, and network security.",
        "Understanding ethical, legal, and social issues in computing.",
        "Completing course projects, lab work, and collaborative assignments to strengthen practical knowledge.",
      ],
    },
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "University of Colombo School of Computing",
      duration: "2017 – 2021",
      logo: "https://ugvle.ucsc.cmb.ac.lk/pluginfile.php/2/course/section/2/UCSC_logo1.jpg?time=1745557854109",
      highlights: [
        "Completed major courses in Data Structures, OOP, Operating Systems, and Software Engineering.",
        "Final year project focused on a web-based financial analytics tool with Spring Boot backend.",
        "Developed foundational skills in Java, MySQL, REST APIs, and frontend development.",
        "Graduated with a Second Class Lower Division.",
      ],
    },
  ],
  blogsData: [
    {
      title: "Stripe with Java",
      description:
        "Explore the reasons behind choosing React for a modern portfolio site.",
      link: "https://medium.com/@ravindu.kp/stripe-with-java-1889433cec3e",
      image:
        "https://miro.medium.com/v2/resize:fit:720/format:webp/1*_XftxiTiVc661YVsZ0tUlQ.jpeg",
    },
    {
      title: "React state management with Redux toolkit",
      description:
        "Level up your frontend skills with these advanced but easy-to-use CSS tips.",
      link: "https://medium.com/@ravindu.kp/react-state-management-with-redux-toolkit-c25d14e422ad",
      image:
        "https://miro.medium.com/v2/resize:fit:720/format:webp/1*uwwuNqk56ANGlZplA7qsMA.png",
    },
  ],
  saasProducts: [
    {
      name: "Orbit Focus",
      slug: "orbit-focus",
      tagline: "The Deep Work Operating System for Modern Engineers.",
      problem: "Traditional productivity tools are built for office managers, not deep-thinking engineers. Context switching, notification noise, and fragmented workflows are the enemies of flow state.",
      solution: "Orbit Focus is a high-performance productivity ecosystem that hardcodes flow state into your workflow. It combines intelligent session tracking, deep-work analytics, and distraction-blocking automation into a single, sleek command center.",
      status: "Alpha",
      features: [
        { title: "Flow Velocity Tracking", desc: "Measure your productivity in 'flow units' rather than just hours clocked." },
        { title: "Context Guard", desc: "Automatically silences distracting notifications based on your current coding focus." },
        { title: "Unified Command Center", desc: "Integrate Github, Jira, and Slack directly into your focus timer." }
      ],
      tech: ["Next.js", "TurboRepo", "Redis", "WebSockets"],
      link: "#",
      waitlistUrl: "#",
      featured: true,
    },
    {
      name: "SwiftPay",
      slug: "swift-pay",
      tagline: "Global payments for local startups.",
      problem: "Complex cross-border transactions for small businesses.",
      status: "Coming Soon",
      tech: ["Java", "Spring Boot", "Stripe"],
      link: "#",
      featured: false,
    }
  ],
  brand: {
    logoText: "RM",
    tagline: "Building scalable products that matter.",
    philosophy: "I believe in building software that doesn't just solve problems, but empowers people to achieve more."
  },
  contact: {
    email: "ravindu.kp@gmail.com",
    linkedin: "https://www.linkedin.com/in/ravindukp/",
    github: "https://github.com/RAVINDULM",
  }
};

export default resumeData;
